import "./App.css";
import Questions from "./Components/Questions";
import {
    BrowserRouter as Router,
    Routes,
    Route,
    BrowserRouter,
} from "react-router-dom";
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import { LoaadingContext } from "./JS/UseContext/LoaadingContext";
import { CallService, modalAlert } from "./JS/scripts";
import Loading from "./Components/Loading";
import { useIsLoading, useSetIsLoading } from "./JS/UseContext/LoaadingContext";

function Main() {
    const navigate = useNavigate();
    const setIsLoading = useSetIsLoading();
    const IsLoading = useIsLoading();
    const [questionsPathSt, setQuestionsPathSt] = useState();

    useEffect(() => {
        var preparedPath = window.location.pathname
            .split("/")
            .filter((x) => x && x != "index.html");
        var pathData = {
            surveyId: preparedPath[0],
            reference: preparedPath[1],
            secondReferenceId: preparedPath[2],
        };
        if (!pathData.surveyId && !pathData.reference) {
            modalAlert("لطفا آدرس را به درستی وارد کنید.");
        }

        setQuestionsPathSt(
            process.env.PUBLIC_URL +
                Object.keys(pathData)
                    .map((key) => (pathData[key] ? `/:${key}` : ""))
                    .join("")
        );

        navigate(`${process.env.PUBLIC_URL}/` + preparedPath.join("/"), {
            state: pathData,
        });
    }, []);

    return (
        <div id="Main">
            {IsLoading && <Loading />}
            <Routes>
                <Route path={questionsPathSt} element={<Questions />} />
            </Routes>
        </div>
    );
}

function App() {
    return (
        <BrowserRouter>
            <LoaadingContext>
                <Main />
            </LoaadingContext>
        </BrowserRouter>
    );
}

export default App;
